import type {
  CrmCampanha,
  CrmCanal,
  CrmConversa,
  CrmEstagio,
  CrmMensagem,
  CrmOrigem,
} from "@/types/crm";

/** Demo visual do CRM — não grava no banco. Desligue quando houver dados reais. */
export const CRM_DEMO_VISUAL = true;

const now = Date.now();
const DAY = 86_400_000;
const HOUR = 3_600_000;

function iso(msAgo: number) {
  return new Date(now - msAgo).toISOString();
}

export const MOCK_CANAL_BOT = "demo-canal-bot";
export const MOCK_CANAL_HUMANO = "demo-canal-humano";

export const MOCK_CANAIS: CrmCanal[] = [
  {
    id: MOCK_CANAL_BOT,
    nome: "Robô de Atendimento",
    numero: "+5541999000001",
    instancia_evolution: "sunpro-bot",
    tipo: "bot",
    ativo: true,
    created_at: iso(90 * DAY),
    updated_at: iso(1 * DAY),
  },
  {
    id: MOCK_CANAL_HUMANO,
    nome: "Comercial (Humano)",
    numero: "+5541999000002",
    instancia_evolution: "sunpro-humano",
    tipo: "humano",
    ativo: true,
    created_at: iso(90 * DAY),
    updated_at: iso(1 * DAY),
  },
];

type Seed = {
  id: string;
  nome: string;
  tel: string;
  estagio: CrmEstagio;
  origem: CrmOrigem;
  ia: boolean;
  naoLidas: number;
  preview: string;
  msgAgo: number;
  createdAgo: number;
  cliente?: number | null;
};

const SEEDS: Seed[] = [
  { id: "demo-01", nome: "Ana Paula Costa", tel: "+5541998101001", estagio: "novo", origem: "inbound_bot", ia: true, naoLidas: 3, preview: "Oi, quero saber sobre proteção solar", msgAgo: 12 * HOUR, createdAgo: 14 * HOUR },
  { id: "demo-02", nome: "Carlos Mendes", tel: "+5541998101002", estagio: "novo", origem: "campanha_marketing", ia: true, naoLidas: 1, preview: "Vi a promoção no WhatsApp", msgAgo: 5 * HOUR, createdAgo: 6 * HOUR },
  { id: "demo-03", nome: "Juliana Rocha", tel: "+5541998101003", estagio: "aguardando_resposta", origem: "inbound_bot", ia: true, naoLidas: 2, preview: "Ainda está disponível o plano anual?", msgAgo: 2 * HOUR, createdAgo: 3 * DAY },
  { id: "demo-04", nome: "Ricardo Alves", tel: "+5541998101004", estagio: "aguardando_resposta", origem: "inbound_humano", ia: false, naoLidas: 0, preview: "Enviei a foto do telhado", msgAgo: 28 * HOUR, createdAgo: 4 * DAY },
  { id: "demo-05", nome: "Fernanda Lima", tel: "+5541998101005", estagio: "ia_atendendo", origem: "inbound_bot", ia: true, naoLidas: 0, preview: "IA: Posso te ajudar com valores e cobertura.", msgAgo: 40 * HOUR, createdAgo: 5 * DAY },
  { id: "demo-06", nome: "Bruno Teixeira", tel: "+5541998101006", estagio: "ia_atendendo", origem: "handoff_bot", ia: true, naoLidas: 4, preview: "Quero falar com um consultor", msgAgo: 1 * HOUR, createdAgo: 2 * DAY },
  { id: "demo-07", nome: "Patrícia Souza", tel: "+5541998101007", estagio: "humano_atendendo", origem: "handoff_bot", ia: false, naoLidas: 0, preview: "Combinado, mando a proposta hoje", msgAgo: 3 * HOUR, createdAgo: 6 * DAY },
  { id: "demo-08", nome: "Eduardo Nunes", tel: "+5541998101008", estagio: "humano_atendendo", origem: "inbound_humano", ia: false, naoLidas: 1, preview: "Pode parcelar no cartão?", msgAgo: 50 * HOUR, createdAgo: 8 * DAY },
  { id: "demo-09", nome: "Mariana Dias", tel: "+5541998101009", estagio: "humano_atendendo", origem: "campanha_renovacao", ia: false, naoLidas: 0, preview: "Estou analisando a renovação", msgAgo: 8 * HOUR, createdAgo: 10 * DAY },
  { id: "demo-10", nome: "Gustavo Pires", tel: "+5541998101010", estagio: "renovacao_andamento", origem: "campanha_renovacao", ia: false, naoLidas: 2, preview: "Meu plano vence mês que vem", msgAgo: 6 * HOUR, createdAgo: 12 * DAY, cliente: 101 },
  { id: "demo-11", nome: "Helena Martins", tel: "+5541998101011", estagio: "renovacao_andamento", origem: "campanha_renovacao", ia: true, naoLidas: 0, preview: "IA: Renovação com 10% de desconto", msgAgo: 20 * HOUR, createdAgo: 15 * DAY, cliente: 102 },
  { id: "demo-12", nome: "Lucas Barbosa", tel: "+5541998101012", estagio: "fechado_ganho", origem: "inbound_bot", ia: false, naoLidas: 0, preview: "Fechado! Obrigado pelo suporte", msgAgo: 4 * DAY, createdAgo: 18 * DAY, cliente: 103 },
  { id: "demo-13", nome: "Camila Freitas", tel: "+5541998101013", estagio: "fechado_ganho", origem: "campanha_marketing", ia: false, naoLidas: 0, preview: "Contrato assinado", msgAgo: 9 * DAY, createdAgo: 22 * DAY, cliente: 104 },
  { id: "demo-14", nome: "Roberto Silva", tel: "+5541998101014", estagio: "fechado_ganho", origem: "inbound_humano", ia: false, naoLidas: 0, preview: "Pagamento confirmado", msgAgo: 16 * DAY, createdAgo: 28 * DAY },
  { id: "demo-15", nome: "Beatriz Gomes", tel: "+5541998101015", estagio: "fechado_perdido", origem: "inbound_bot", ia: true, naoLidas: 0, preview: "Vou ficar só com o seguro da concessionária", msgAgo: 11 * DAY, createdAgo: 20 * DAY },
  { id: "demo-16", nome: "Thiago Ramos", tel: "+5541998101016", estagio: "fechado_perdido", origem: "campanha_marketing", ia: true, naoLidas: 0, preview: "Fora do orçamento no momento", msgAgo: 25 * DAY, createdAgo: 35 * DAY },
  { id: "demo-17", nome: "Aline Castro", tel: "+5541998101017", estagio: "sem_interesse", origem: "campanha_marketing", ia: true, naoLidas: 0, preview: "Não tenho usina fotovoltaica", msgAgo: 30 * DAY, createdAgo: 40 * DAY },
  { id: "demo-18", nome: "Diego Ferreira", tel: "+5541998101018", estagio: "novo", origem: "inbound_bot", ia: true, naoLidas: 5, preview: "Bom dia! Preciso de orçamento urgente", msgAgo: 25 * HOUR, createdAgo: 26 * HOUR },
  { id: "demo-19", nome: "Sofia Andrade", tel: "+5541998101019", estagio: "ia_atendendo", origem: "inbound_bot", ia: true, naoLidas: 0, preview: "IA: Cobertura contra danos elétricos e granizo", msgAgo: 7 * DAY, createdAgo: 9 * DAY },
  { id: "demo-20", nome: "Paulo Henrique", tel: "+5541998101020", estagio: "fechado_ganho", origem: "campanha_renovacao", ia: false, naoLidas: 0, preview: "Renovação concluída", msgAgo: 45 * DAY, createdAgo: 50 * DAY, cliente: 105 },
  // Volume extra para o gráfico semanal (semanas anteriores)
  { id: "demo-21", nome: "Vera Lopes", tel: "+5541998101021", estagio: "fechado_ganho", origem: "inbound_bot", ia: false, naoLidas: 0, preview: "Obrigada!", msgAgo: 55 * DAY, createdAgo: 56 * DAY },
  { id: "demo-22", nome: "André Vieira", tel: "+5541998101022", estagio: "fechado_perdido", origem: "campanha_marketing", ia: true, naoLidas: 0, preview: "Não agora", msgAgo: 48 * DAY, createdAgo: 49 * DAY },
  { id: "demo-23", nome: "Natália Reis", tel: "+5541998101023", estagio: "humano_atendendo", origem: "inbound_humano", ia: false, naoLidas: 0, preview: "Vamos agendar a vistoria", msgAgo: 14 * DAY, createdAgo: 15 * DAY },
  { id: "demo-24", nome: "Fábio Moura", tel: "+5541998101024", estagio: "aguardando_resposta", origem: "campanha_marketing", ia: true, naoLidas: 1, preview: "Recebi o material, vou ler", msgAgo: 18 * DAY, createdAgo: 19 * DAY },
];

export const MOCK_CONVERSAS: CrmConversa[] = SEEDS.map((s) => ({
  id: s.id,
  telefone_cliente: s.tel,
  nome_contato: s.nome,
  cliente_id: s.cliente ?? null,
  canal_id: s.ia ? MOCK_CANAL_BOT : MOCK_CANAL_HUMANO,
  estagio: s.estagio,
  responsavel_id: s.ia ? null : "demo-user",
  ia_ativa: s.ia,
  origem: s.origem,
  nao_lidas: s.naoLidas,
  ultima_msg_preview: s.preview,
  ultima_msg_em: iso(s.msgAgo),
  created_at: iso(s.createdAgo),
  updated_at: iso(s.msgAgo),
}));

export const MOCK_CAMPANHAS: CrmCampanha[] = [
  {
    id: "demo-camp-1",
    nome: "Renovação D-30 — Abril",
    descricao: "Clientes com vencimento nos próximos 30 dias",
    tipo: "renovacao",
    mensagem_texto: "Olá {nome}, sua proteção SunPro vence em breve. Quer renovar com condições especiais?",
    canal_id: MOCK_CANAL_BOT,
    filtros: { estado: "PR" },
    status: "concluida",
    total_destinatarios: 86,
    total_enviados: 82,
    total_erros: 4,
    agendado_para: null,
    criado_por: null,
    created_at: iso(20 * DAY),
    updated_at: iso(18 * DAY),
  },
  {
    id: "demo-camp-2",
    nome: "Campanha proteção granizo",
    descricao: "Base SP e PR",
    tipo: "marketing",
    mensagem_texto: "Olá {nome}, proteja sua usina contra granizo com a SunPro.",
    canal_id: MOCK_CANAL_BOT,
    filtros: { estado: null, cidade: null },
    status: "em_andamento",
    total_destinatarios: 240,
    total_enviados: 118,
    total_erros: 2,
    agendado_para: null,
    criado_por: null,
    created_at: iso(3 * DAY),
    updated_at: iso(1 * HOUR),
  },
  {
    id: "demo-camp-3",
    nome: "Onboarding novos clientes",
    descricao: null,
    tipo: "onboarding",
    mensagem_texto: "Bem-vindo(a) {nome}! Seu atendimento SunPro começa aqui.",
    canal_id: MOCK_CANAL_BOT,
    filtros: null,
    status: "rascunho",
    total_destinatarios: 32,
    total_enviados: 0,
    total_erros: 0,
    agendado_para: null,
    criado_por: null,
    created_at: iso(1 * DAY),
    updated_at: iso(1 * DAY),
  },
];

export const MOCK_MENSAGENS: Record<string, CrmMensagem[]> = {
  "demo-01": [
    {
      id: "m1",
      conversa_id: "demo-01",
      canal_id: MOCK_CANAL_BOT,
      direcao: "in",
      corpo: "Oi, quero saber sobre proteção solar",
      autor: "cliente",
      evolution_message_id: null,
      status_envio: "entregue",
      enviada_por: null,
      created_at: iso(14 * HOUR),
    },
    {
      id: "m2",
      conversa_id: "demo-01",
      canal_id: MOCK_CANAL_BOT,
      direcao: "out",
      corpo: "Olá Ana! Sou a assistente SunPro. Posso te explicar coberturas e valores.",
      autor: "ia",
      evolution_message_id: null,
      status_envio: "lido",
      enviada_por: null,
      created_at: iso(13.5 * HOUR),
    },
    {
      id: "m3",
      conversa_id: "demo-01",
      canal_id: MOCK_CANAL_BOT,
      direcao: "in",
      corpo: "Tenho 16 painéis em Curitiba. Quanto fica?",
      autor: "cliente",
      evolution_message_id: null,
      status_envio: "entregue",
      enviada_por: null,
      created_at: iso(12 * HOUR),
    },
  ],
  "demo-07": [
    {
      id: "m4",
      conversa_id: "demo-07",
      canal_id: MOCK_CANAL_HUMANO,
      direcao: "in",
      corpo: "Prefiro falar com uma pessoa",
      autor: "cliente",
      evolution_message_id: null,
      status_envio: "entregue",
      enviada_por: null,
      created_at: iso(7 * HOUR),
    },
    {
      id: "m5",
      conversa_id: "demo-07",
      canal_id: MOCK_CANAL_HUMANO,
      direcao: "out",
      corpo: "Oi Patrícia, aqui é o comercial SunPro. Vou montar sua proposta hoje.",
      autor: "operador",
      evolution_message_id: null,
      status_envio: "lido",
      enviada_por: "demo-user",
      created_at: iso(5 * HOUR),
    },
    {
      id: "m6",
      conversa_id: "demo-07",
      canal_id: MOCK_CANAL_HUMANO,
      direcao: "out",
      corpo: "Combinado, mando a proposta hoje",
      autor: "operador",
      evolution_message_id: null,
      status_envio: "entregue",
      enviada_por: "demo-user",
      created_at: iso(3 * HOUR),
    },
  ],
};

export function filterMockConversas(
  filtro?: {
    estagio?: CrmEstagio | null;
    busca?: string | null;
    apenasMinhas?: boolean;
  },
  userId?: string | null
): CrmConversa[] {
  let list = [...MOCK_CONVERSAS];
  if (filtro?.estagio) list = list.filter((c) => c.estagio === filtro.estagio);
  if (filtro?.apenasMinhas) {
    list = list.filter((c) => !c.ia_ativa && (c.responsavel_id === "demo-user" || !!userId));
  }
  if (filtro?.busca?.trim()) {
    const term = filtro.busca.trim().toLowerCase();
    list = list.filter(
      (c) =>
        (c.nome_contato ?? "").toLowerCase().includes(term) ||
        c.telefone_cliente.toLowerCase().includes(term)
    );
  }
  return list.sort(
    (a, b) => new Date(b.ultima_msg_em).getTime() - new Date(a.ultima_msg_em).getTime()
  );
}

export function getMockMensagens(conversaId: string): CrmMensagem[] {
  if (MOCK_MENSAGENS[conversaId]) return MOCK_MENSAGENS[conversaId];
  const conv = MOCK_CONVERSAS.find((c) => c.id === conversaId);
  if (!conv) return [];
  return [
    {
      id: `${conversaId}-in`,
      conversa_id: conversaId,
      canal_id: conv.canal_id,
      direcao: "in",
      corpo: conv.ultima_msg_preview || "Olá",
      autor: "cliente",
      evolution_message_id: null,
      status_envio: "entregue",
      enviada_por: null,
      created_at: conv.ultima_msg_em,
    },
  ];
}
